import styles from "./RectangleFrame.module.css";

const RectangleFrame = () => {
  return (
    <div className={styles.rectangle6ContainerParent}>
      <div className={styles.rectangle6Container} />
    </div>
  );
};

export default RectangleFrame;
